module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"url":{"label":"URL address","placeholder":"https://"},"name":{"label":"Name","placeholder":"Enter your website, blog or social media profile name"},"categories":{"label":"Category","placeholder":"Select"},"type":{"label":"Type","placeholder":"Select"},"button":{"submit":"Next"},"msgSuccess":"The „{name}” page was successfully created."}}')
  delete Component.options._Ctor
}
